import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--marker-gandalf)";

const ROTATE_VALUE_TOP = 0;
const ROTATE_VALUE_RIGHT = 90;
const ROTATE_VALUE_BOTTOM = 180;
const ROTATE_VALUE_LEFT = 270;

enum ChevronSide {
    Top = "top",
    Right = "right",
    Bottom = "bottom",
    Left = "left"
}

interface Props extends IconProps {
    side?: ChevronSide;
}

function calculateRotationByPosition(side: ChevronSide): number {
    switch (side) {
        case ChevronSide.Top:
            return ROTATE_VALUE_TOP;
        case ChevronSide.Right:
            return ROTATE_VALUE_RIGHT;
        case ChevronSide.Bottom:
            return ROTATE_VALUE_BOTTOM;
        case ChevronSide.Left:
            return ROTATE_VALUE_LEFT;
        // no default
    }
}

function IconChevron({
    class: cssClass,
    color,
    side = ChevronSide.Top
}: Props) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;
    const rotation = calculateRotationByPosition(side);

    return (
        <svg class={cssClass} width="6" height="3" viewBox="0 0 6 3" fill="none" style={{ transform: `rotate(${rotation}deg)` }} xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M3.303.11a.473.473 0 0 0-.606 0L.126 2.36a.343.343 0 0 0 0 .53.473.473 0 0 0 .606 0L3 .905 5.268 2.89a.473.473 0 0 0 .606 0 .343.343 0 0 0 0-.53L3.303.11z"/>
        </svg>
    );
}

export default IconChevron;
export { ChevronSide };
